import axios from "axios";

const http = axios.create({
    baseURL: '',     // 'http://test.ads-goal.com'
    timeout: 3000,                               // 3s
})

// request
http.interceptors.request.use(
    config => {
        // console.log('interceptors request');
        // console.log(config);
        const token = localStorage.getItem('token'); // get token
        if (token) {
            config.headers['token'] = token; // set-token
        }
        return config;
    },
    err => {
        return Promise.reject(err);
    }
);

// response
// let requestNumber = 0;
http.interceptors.response.use(
    res => {
        // console.log('interceptors response');
        // console.log(res);
        if (res.status == 200) {
            return Promise.resolve(res);
        }
    },
    err => {
        // console.log(err);
        const { config, code, message } = err;
        // console.log(config, code, message);
       /*  if (code === 'ECONNABORTED' || message === 'Network Error') {
            // 请求超时
            requestNumber++;
            if(requestNumber >= 3) { // 请求3次后停止请求
                console.warn(`请求超时，结束请求`);
                return
            }
            
            console.warn(`请求超时，将在3秒后重试,请求次数:${requestNumber}`);
        } */
        /* return new Promise(resolve => {
            setTimeout(async () => {
                resolve(await http.request(config))
            }, 3000) // come back Request
        }) */

    }
)


export default http;